$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var burger_message = $('.burger-instruction');
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');
    var break_point = 1200;
    let browser_width = $(window).innerWidth();
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                $('.menu-item-has-children').removeClass('__active');
                body.removeClass('__blur');
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div, button, a').removeClass('__active');
        body.removeClass('__blur');
        burger_message.text('Open menu');
        nav_trigger.siblings('ul').removeAttr('style'); 
        nav_trigger.attr('aria-expanded', false).parents().removeClass('__active');
        let browser_width = $(window).innerWidth();
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        burger_message.text('Close');
    };
   
    function initMenu() {
        var browser_width = window.innerWidth;
        $(".navwrap *").unbind();

        $( ".navwrap ul").on( "mouseenter focusin", function() {
            $('.navwrap ul').each(function () {
                var elem = $(this)
                var rect = elem[0].getBoundingClientRect();
                if(rect.x + rect.width > window.innerWidth) {
                    $(this).addClass('left');
                }
            });
        });

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            nav_trigger.click(function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).parent().siblings().removeClass('__active');
                    $(this).parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().toggleClass('__active');
                    body.addClass('__blur');

                    if ($(this).parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                        nav_trigger.siblings('ul').removeAttr('style');  
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().find('.__active').removeClass('__active');
                        body.removeClass('__blur');
                    }
                }

                // Set height of the grandchild, according to the height of its parent menu-item
                // This results in both items being the same height
                $('.nav .menu-item-has-children').each(function () {
                    var childItems = $(this).find('> ul > .menu-item-has-children');
                    childItems.each(function () {
                        var firstGrandchildItem = $(this).find('> ul > .menu-item:first-child');
                        var childHeight = $(this).outerHeight();
                        firstGrandchildItem.css('height', childHeight + 'px');
                    });
                });
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                    body.removeClass('__blur');
                }
            });
        }

        if (browser_width < break_point) {
            nav_trigger.on('click', function (event) {
                if ($(this).hasClass('__active')) {
                    $(this).removeClass('__active');
                    $(this).siblings('ul').removeClass('__active').slideUp();
                    $(this).parents('li').siblings('li').find('ul, a, button').removeClass('__active');
                    $(this).siblings('ul').find('ul, a, button').removeClass('__active');
                }
                else {
                    event.preventDefault();
                    $(this).addClass('__active');
                    $(this).siblings('ul').addClass('__active').slideDown();
                    $(this).parents('li').siblings('li').find('ul, a, button').removeClass('__active');
                    $(this).parents('li').siblings('li').find('ul').slideUp();
                }
            });
        }       

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }

        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }
    }

    // find initial browser size
    onResizeReadMoreLayout();
    // on resize reset the navigation items
    $(window).on('resize', onResizeReadMoreLayout);
    function onResizeReadMoreLayout() {
        if ($(window).width() >= 1200) {
            nav_reset();
        }
    }

    // reset nav on scroll past the height of the window
    $(window).scroll(function () {
        if (browser_width >= break_point) {
            var scrollDistance = 350;
            var scrollTop = $(window).scrollTop();

            if (scrollTop > scrollDistance) {
                nav_reset();
            }
        };
    });
    
    initMenu();

    $(window).resize(function(){
        initMenu();
        nav_reset();
    });
});